



























































































































import { Component, Prop } from 'vue-property-decorator';
import { SwIcon, IconConfig } from '../sw-icon';
import { CSSStyleOptions, VueRenderFunction } from '../common-types';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';

const cssPrefix = 'sw-icon-tab';

/**
 * @event click `(event: MouseEvent)`
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwIconTab extends SwExtendedVue {
  @Prop({ type: String, default: 'light' }) theme : string;

  @Prop({ type: String, default: 'header' })
  mode: 'header' | 'page';

  @Prop({ type: [String, Object], required: true })
  icon: string | IconConfig;

  @Prop({ type: [String, Function], default: '' })
  text: string | VueRenderFunction;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: String, default: utilService.colorConst.selected })
  tabColor: string;

  @Prop({ type: Boolean, default: false })
  noBorder: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  cssPrefix: string = cssPrefix;

  isOnIcon: boolean = false;

  get effectiveIcon(): IconConfig {
    return Object.assign(
      {
        size: this.mode === 'page' ? 28 : 20,
      },
      typeof this.icon === 'string' ? { name: this.icon } : this.icon,
    );
  }

  get iconStyle(): CSSStyleOptions {
    if (this.disabled) {
      return {
        color: utilService.colorConst.light_textDisabled,
        backgroundColor: utilService.colorConst.light_highlight,
        borderColor: utilService.colorConst.light_textDisabled,
      };
    }
    return {
      borderColor: this.tabColor,
      backgroundColor: this.selected ? this.tabColor : undefined,
      color: this.isOnIcon ? (this.selected || this.noBorder ? (this.theme === 'dark' ? '#cccccc' : undefined) : this.tabColor) : undefined,
    };
  }

  get noBorderIconStyle(): CSSStyleOptions {
    if (this.noBorder) {
      return {
        backgroundColor: this.iconStyle.backgroundColor,
        color: this.iconStyle.color,
      };
    }
    return {};
  }

  onMouseEnterIcon() {
    this.isOnIcon = true;
  }

  onMouseLeaveIcon() {
    this.isOnIcon = false;
  }

  onClickIcon(event: MouseEvent) {
    if (!this.noBorder) {
      this.$emit('click', event);
    }
  }

  onClickOuter(event: MouseEvent) {
    if (this.noBorder) {
      this.$emit('click', event);
    }
  }
}
